import {apiGet} from '@api/api'
import {ApiRes} from '@type/api'
import {IInvoice} from '@type/invoice'
import {IApiBaseProps} from '@api/user/sidebar/getSidebar'

export const apiGetPendingInvoices = async (props?: IApiBaseProps): Promise<ApiRes<IInvoice[]>> => {
    return await apiGet(`payment/invoices?status=pending`, {cookies: props?.cookie})
}
